<template lang="html">
  <b-container class="admin-page">
    <div>

      <div class="sezione-utente-corrente" >
        <div class="introduzione-sezione">
          <div class="intestazine-titolo">
            Area Utente
          </div>
          <div class="intestazione-descrizione">
            In questa Sezione potrai modificare le tue informazioni personali, <br>
            Da Partner potrai inserire nuovi prodotti nella piattaforma<br>
            Da Cliente/Fornitore potrai effettuare degli ordini
          </div>
        </div>
        <div class="dati-utente">
          <div class="immagine-utente">
            <div class="immagine-profilo" v-if="! current_user.images ">
              +
            </div>
            <div v-else class="user-image">
              <img v-if="current_user.images.length" :src="$url(current_user.images[0].thumb.lg)" alt="">
            </div>

          </div>

          <div class="user-data">
            <div class="info-personali">
              <div class="riga-dati">
                <span class="light-gray">Nome:</span>
                {{current_user.name}}
              </div>
              <div class="riga-dati">
                <span class="light-gray">Cognome:</span>
                {{current_user.surname}}
              </div>
              <div class="riga-dati">
                <span class="light-gray">Azienda:</span>
                {{current_user.company}}
              </div>
              <div class="riga-dati">
                <span class="light-gray">Mail:</span>
                {{current_user.email}}
              </div>
              <div class="riga-dati">
                <span class="light-gray">Telefono:</span>
                {{current_user.phone_number}}
              </div>

            </div>
            <div class="info-posizione">
              <div class="riga-dati">
                <span class="light-gray">Indirizzo:</span>
                {{current_user.addr_street}}
              </div>
              <div class="riga-dati">
                <span class="light-gray">Città:</span>
                {{current_user.addr_city}}
              </div>
              <div class="riga-dati">
                <span class="light-gray">CAP:</span>
                {{current_user.addr_zip}}
              </div>
              <div class="riga-dati">
                <span class="light-gray">Provincia:</span>
                {{current_user.addr_prov}}
              </div>


            </div>
          </div>
        </div>
        <!-- <div class="statistiche-utente">
          <div class="">
            Numero annunci inserirti <br>
          </div>
          <div class="">
            Alberi salvati:
          </div>
          <div class="">
            Emissioni CO2 evitate
          </div>
        </div> -->


      </div>

    </div>
    <div class="edit-user-button">
      <button type="button" @click="form = _.cloneDeep(current_user)">Modifica</button>
    </div>
    <b-modal :visible="!!form" @hidden="form = null" hide-footer hide-header size="lg">
      <user-form v-if="form" :form="form" @saved="get_current_user_data()" @close="form=null"/>
    </b-modal>

    <!--  -->
    <div class="your-orders">
      Le tue richieste
    </div>

    <Orders>
    </Orders>

    <div class="your-orders" >
      Le tue disponibiltà
    </div>
    <Products >
    </Products>
    <!-- <div class="your-orders" v-if="$store.user.type != 'client' ">
      Le tue disponibiltà
    </div>
    <Products v-if="$store.user.type != 'client' ">
    </Products> -->

  </b-container>
</template>

<script>
import Products from '@/views/products'
import Orders from '@/views/orders'
import UserForm from '@/components/user-form'
// import UserForm from '@/components/user-form'

export default {
  // components: {
  //   UserForm,
  // },
   components: {
      Products,
      Orders,
      UserForm,
      // UserForm
    },

  data() {
    return {
      users: null,
      page: 1,
      form: null,
      show: true,
      showDeleteModal: true,
      current_user : null,

      orders: null,

    }
  },

  created() {
    this.refreshOrders()
    this.get_current_user_data()
  },
  methods: {
    get_current_user_data(){
      this.current_user = this.$http.get('self').then(res => {
        this.current_user = res.data
      })
    },


    refreshOrders() {
      let params = {
        page: this.page,
      }
      this.$http.get('orders', {
        params
      }).then(res => {
        this.orders = res.data
      })
    },
    deleteOrder(id) {
      if (!confirm('Sicuro?')) return null
      this.$http.delete('orders/' + id).then(() => {
        this.refreshOrders()
      })
    },


  },
  watch: {
    page() {
      this.refreshOrders()
    }
  }


}
</script>

<style lang="scss">
  .immagine-profilo{
    height:200px;
    width: 200px;
    border:1px solid black;
    display: flex;
    justify-content: center;
    align-items: center;
    font-size:40px;
    border-radius: 20px;
  }
  .dati-utente{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: row;
  }
  .user-data{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    flex-direction: row;
    padding-left: 30px;
    width: 100%;

  }
  .info-personali{
    padding-right:100px;
  }
  .light-gray{
    color: #ccc;
  }
  .statistiche-utente{
    padding-bottom:60px;
  }
  .riga-dati{
    display: flex;
    width: 100%;
    justify-content: space-between;
    align-items: center;
    border-bottom:1px solid #ccc;
    padding-top: 5px;
    padding-bottom: 5px;
  }
  .info-personali{
    width: 100%;
  }
  .info-posizione{
    width: 100%;
  }
  .statistiche-utente{
    padding-top:40px;
    display: flex;
    justify-content: space-between;
    align-items: center;
    flex-direction: row;
  }
  .sezione-utente-corrente{
    padding-top:40px;
  }

  .your-orders{
    padding-top:20px;
    padding-bottom:20px;
    width: 100%;
    text-align: left;
    font-size:28px;
    color:#81bb5d;
  }
  .user-image img{
    max-width:250px;
  }
  .admin-page{
    min-height:1000px;
  }
  .introduzione-sezione{
    display: flex;
    justify-content: flex-start;
    align-items: flex-start;
    width: 100%;
    flex-direction: row;
    text-align: left;
    padding-bottom:40px;
  }
  .intestazine-titolo{
    font-size:35px;
    color:#81bb5d;
    width:100%;
  }
  .intestazione-descrizione{
    font-size:18px;
    width:100%;
    text-align: left;
    padding-top:5px;
    padding-bottom:15px;
  }
  .edit-user-button{
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
    flex-direction: row;
  }
  .edit-user-button button{
    color: white;
    background-color: #81bb5d;
    border:1px solid #81bb5d;
    border-radius:20px;
    padding: 10px 20px;
  }
</style>
